export default __webpack_public_path__ + "static/media/likert-face-1.e2a4a672.svg";